export interface ApiCalendarPayload {
  dateStart: string;
  dateEnd: string;
}

interface CalendarArticle {
  icon_number: number;
  text: string;
  type: number;
}

interface MoonData {
  articles: CalendarArticle[];
  moon_phase: number;
}

interface ZodiacData {
  articles: CalendarArticle[];
  zodiac: number[];
  day_type: number[];
}

export interface ApiCalendarData {
  date: number;
  moon: MoonData;
  zodiac: ZodiacData;
}

export enum EVENTS {
  'leaf' = 1,
  'fruit' = 2,
  'root' = 3,
  'flower' = 4,
}

export interface ApiCalendarDataFormated extends ApiCalendarData {
  dateString: string;
  date: number;
  dateShortName: string;
  dateFullName: string;
  weekDay: string;
  eventType: keyof typeof EVENTS | null;
  isToday: boolean;
  isInMonth: boolean;
}
